<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @submit="handleSearch" :autoFormCreate="
        (form) => {
          this.searchForm = form;
        }
      ">
        <a-row :gutter="48">
          <a-col :md="12" :sm="24">
            <a-form-item label="查询日期" fieldDecoratorId="date_time">
              <a-range-picker :show-time="{ format: 'HH:mm' }" format="YYYY-MM-DD HH:mm"
                :placeholder="['开始时间', '结束时间']" style="width:100%"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="所属门店" fieldDecoratorId="branch_id">
              <a-select placeholder="请选择" allowClear show-search option-filter-prop="children">
                <a-select-option v-for="item in branches" :key="item.id">{{
                    item.name
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="审阅状态" fieldDecoratorId="status">
              <a-select placeholder="请选择" allowClear>
                <a-select-option :key="1">已审核</a-select-option>
                <a-select-option :key="2">未审核</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="异动操作人" fieldDecoratorId="admin_user_id">
              <a-select placeholder="请选择" allowClear show-search option-filter-prop="children">
                <a-select-option v-for="item in operators" :key="item.id">{{
                    item.real_name
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" htmlType="submit">查询</a-button>
              <a-divider type="vertical" />
              <a-button style="margin-left: 8px" @click="handleExport">导出</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- <div class="table-operator">
      <a-button type="primary" @click="handleSelect">复盘</a-button>
    </div> -->
    <s-table ref="table" size="default" :columns="columns" :data="loadData">
      <template slot="pic_url" slot-scope="text">
        <span class="pic"><img :src="text" /></span>
      </template>
      <template slot="merchandiser_admin_user" slot-scope="text, record">
        <span v-if="record.merchandiser_admin_user_id">{{ text }}</span>
        <span v-else style="color:#aaa">未审阅</span>
      </template>
      <template slot="operations_admin_user" slot-scope="text, record">
        <span v-if="record.operations_admin_user_id">{{ text }}</span>
        <span v-else style="color:#aaa">未审阅</span>
      </template>
      <template slot="merchandiser_additional_remarks" slot-scope="text, record">
        <span v-if="record.merchandiser_admin_user_id && text">{{ text }}</span>
        <span v-else-if="record.merchandiser_admin_user_id" style="color:#aaa">无需额外处理</span>
        <span v-else style="color:#aaa">未审阅</span>
      </template>
      <template slot="operations_additional_remarks" slot-scope="text, record">
        <span v-if="record.operations_admin_user_id && text">{{ text }}</span>
        <span v-else-if="record.operations_admin_user_id" style="color:#aaa">无需额外处理</span>
        <span v-else style="color:#aaa">未审阅</span>
      </template>
      <template slot="is_additional" slot-scope="text, record">
        <span v-if="record.additional_remarks">是</span>
        <span v-else>否</span>
      </template>
      <template slot="is_confirm" slot-scope="text, record">
        <span v-if="text">{{text | isConfirm}}</span>
        <a-popover title="是否同意该库存变动？" trigger="click" v-else :ref="'confirm' + record.id">
          <template slot="content">
            <div style="text-align:right">
              <a-button size="small" type="danger" style="color:#fff;background:#ff4d4f;border:none" @click="confirm(false,record.id)">拒绝</a-button>
              <a-button size="small" type="primary" style="margin-left:8px;" @click="confirm(true,record.id)">同意</a-button>
            </div>
          </template>
          <a type="text">请选择</a>
        </a-popover>
        
      </template>
      <template slot="action" slot-scope="text, record">
        <div class="editable-row-operations">
          <a @click="showRemarks(record)" v-if="record.remarks">查看门店备注</a>
          <a-divider type="vertical" v-if="record.remarks && (role == 'operations' || role == 'merchandiser')" />
          <a @click="handleChange(record)" v-if="role == 'operations' || role == 'merchandiser'">确认异动</a>
        </div>
      </template>
    </s-table>
    <a-modal title="确认异动" :visible="visible" @ok="_handleOk" @cancel="handleCancel" :maskClosable="false">
      是否需要额外处理：
      <a-radio-group :options="[{ label: '是', value: true }, { label: '否', value: false }]" v-model="isAdditional" />
      <div v-if="isAdditional">
        <p style="font-weight:bold;margin-bottom:6px;margin-top:12px;"><span style="color:#f33">*</span>处理方式：</p>
        <a-input type="textarea" v-model.number="currentRecord.remarks" :maxLength="255" />
      </div>
    </a-modal>
  </a-card>
</template>
<script>
import STable from "@/components/table/";
import AInput from "ant-design-vue/es/input/Input";
import { getStockRecordAbnormals, reviewStockRecordAbnormal,confirmStockRecordAbnormal } from "@/api/stock";
import { getBranchList } from "@/api/branch";
import { encodeJsonToQuery } from "@/utils/util";
import { ACCESS_TOKEN } from "@/store/mutation-types";
import { getStaffList } from "@/api/staff";

export default {
  name: "AbnormalInventoryChangeList",
  components: {
    AInput,
    STable,
  },
  filters:{
    isConfirm(value){
      const typeStr = ["未确认","同意","拒绝"]
      return typeStr[value]
    }
  },
  data() {
    return {
      role: this.$store.getters.userInfo.role,
      operators: [],
      isAdditional: false,
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      form: null,
      mdl: {},
      // 查询参数
      searchForm: null,
      branches: [],
      differ: 0,
      queryParam: {},
      columns: [
        {
          title: "商品图片",
          dataIndex: "goods_pic_url",
          scopedSlots: { customRender: "pic_url" },
        },
        {
          title: "商品名称",
          dataIndex: "goods_name",
        },
        {
          title: "异动时间",
          dataIndex: "created",
        },
        {
          title: "变动后库存数",
          dataIndex: "remainder",
        },
        {
          title: "异动数",
          dataIndex: "change_quantity",
        },
        {
          title: "异动操作人",
          dataIndex: "admin_user_name",
        },
        {
          title: "所属门店",
          dataIndex: "branch_name",
        },
        {
          title: "财务审阅",
          scopedSlots: { customRender: "merchandiser_admin_user" },
          dataIndex: "merchandiser_admin_user_name",
        },
        {
          title: "运营审阅",
          scopedSlots: { customRender: "operations_admin_user" },
          dataIndex: "operations_admin_user_name",
        },
        {
          title: "财务处理方式",
          scopedSlots: { customRender: "merchandiser_additional_remarks" },
          dataIndex: "merchandiser_additional_remarks",
        },
        {
          title: "运营处理方式",
          scopedSlots: { customRender: "operations_additional_remarks" },
          dataIndex: "operations_additional_remarks",
        },
        {
          title: "是否同意",
          scopedSlots: { customRender: "is_confirm" },
          dataIndex: "is_confirm",
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: "action" },
        },
      ],
      currentRecord: {
        id: null,
        remarks: "",
      },
      // 加载数据方法 必须为 Promise 对象
      loadData: (params) => {
        return getStockRecordAbnormals(Object.assign(params, this.queryParam)).then(
          (res) => res
        );
      },
    };
  },
  created() {
    this.getBranchList();
    this.getOperators();
  },

  methods: {
    getBranchList: function () {
      getBranchList().then((res) => {
        this.branches = res.list;
      });
    },
    getOperators: function () {
      getStaffList().then((res) => {
        this.operators = res.list;
      });
    },
    confirm(isConfirm,id){
      this.$refs["confirm" + id].$refs.tooltip.sVisible = false
      confirmStockRecordAbnormal({
        id,
        is_confirm:isConfirm ? 1:2
      }).then((res) => {
        this.$refs.table.refresh();
        this.$message.success("提交成功");
        this.currentRecord = {};
      });
      // this.$confirm({
      //   title:"是否同意该库存变动？",
      //   okText:"同意",
      //   cancelText:"拒绝",
      //   closable:true,
      // })
    },
    showRemarks(record) {
      this.$info({
        title: "门店备注",
        content: record.remarks,
      });
    },
    handleSearch(e) {
      e.preventDefault();
      let dateTime = this.searchForm.getFieldValue("date_time")
      this.queryParam = {
        branch_id: this.searchForm.getFieldValue("branch_id"),
        status: this.searchForm.getFieldValue("status"),
        admin_user_id:this.searchForm.getFieldValue("admin_user_id")
      };
      if (dateTime) {
        this.queryParam.start_date = dateTime[0] && dateTime[0].format('YYYY-MM-DD HH:mm:ss')
        this.queryParam.end_date = dateTime[1] && dateTime[1].format('YYYY-MM-DD HH:mm:ss')
      }
      this.$refs.table.refresh();
    },
    handleExport() {
      let dateTime = this.searchForm.getFieldValue("date_time")
      const params = {
        branch_id: this.searchForm.getFieldValue("branch_id"),
        status: this.searchForm.getFieldValue("status"),
        admin_user_id:this.searchForm.getFieldValue("admin_user_id"),
        token: this.$ls.get(ACCESS_TOKEN),
      };
      if (dateTime) {
        params.start_date = dateTime[0] && dateTime[0].format('YYYY-MM-DD HH:mm:ss')
        params.end_date = dateTime[1] && dateTime[1].format('YYYY-MM-DD HH:mm:ss')
      }
      window.open("/api/admin/stock/record/abnormals/excel" + encodeJsonToQuery(params));
    },
    handleReset() {
      this.searchForm.resetFields();
      this.queryParam = {};
      this.$refs.table.refresh();
    },
    handleChange(row) {
      if (this.role == "merchandiser") {
        this.isAdditional = !!row.merchandiser_additional_remarks
      }
      if (this.role == "operations") {
        this.isAdditional = !!row.operations_additional_remarks
      }
      this.currentRecord = {
        id: row.id,
        remarks: this.role == "merchandiser" ? row.merchandiser_additional_remarks : row.operations_additional_remarks
      };
      this.visible = true;
    },
    handleCancel() {
      this.currentRecord = {};
      this.visible = false;
    },
    _handleOk() {
      if (this.isAdditional && !this.currentRecord.remarks) {
        this.$message.error("请填写处理方式")
        return
      }
      reviewStockRecordAbnormal({
        id: this.currentRecord.id,
        remarks: this.isAdditional ? this.currentRecord.remarks.toString() : ""
      }).then((res) => {
        this.$refs.table.refresh();
        this.$message.success("提交成功");
        this.currentRecord = {};
      });
      this.visible = false;
      // Inventory({
      //   id: this.currentRecord.stock_id,
      //   difference: this.currentRecord.difference,
      // }).then((res) => {
      //   this.$refs.table.refresh();
      //   this.$message.success("提交成功");
      //   this.currentRecord = {};
      //   this.visible = false;
      // });
    },
    handleSelect() {
      let routerone = this.$router.resolve({ name: "ReviewInventory" });
      window.open(routerone.href, "_blank");
    },
  },
};
</script>
<style scoped>
.pic {
  width: 50px;
  height: 50px;
}

.barcode {
  width: 150px;
  height: 50px;
}

.barcode>img {
  width: 150px;
  height: 50px;
  display: block;
}

.pic>img {
  width: 50px;
  height: 50px;
  display: block;
}
</style>
